import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router";
import { title } from "../config";
import AppMenu from "../components/AppMenu";
import { Alert, Button, Table } from 'reactstrap';
import { deleteProcess, getProcessData, getAllProcess } from '../services/processAPI';
import moment from 'moment';

const Processes = () => {
    const [tableData, setTableData] = useState([]);
    // this should come from DB 

    useEffect(() => {
        reloadProcess();
    }, []);

    const reloadProcess = async () => {
        let records = await getProcessData();
        setTableData(records);
    };
    const navigate = useNavigate();
    const doEdit = (id) => {
        navigate(`/process/edit/${id}`);
    };
    const doDelete = async (data) => {
        await deleteProcess(data);
        reloadProcess();
    };
    const getFields = () => {
        if (tableData.length > 0) {
            return Object.keys(tableData[0]).filter(key => key !== '_id' && key !== 'lastUpdated' && key !== 'processName');
        }
        return [];
    };
    return (
        <div>
            <div className="px-2" style={{backgroundColor:"#f8f9fa"}}>
        <h3 className="title m-0 p-2">Remote<span style={{color: '#ff6501'}}>Xs</span> Monitor | Process</h3>
                <AppMenu />
                <div className="p-0 px-2 m-0">
                    <div className="px-2">
                        <span className="headerMargin ms-1"><button
                            className="fa-sharp fa-plus btn btn-outline-primary"
                            onClick={() => {
                                navigate("/process/add");
                            }}
                            variant="contained"
                        > Add </button></span>
                        <span style={{ float: "right", marginRight: "10px" }}>
                        </span>
                    </div>
                    <hr className="p-0 my-2" />
                </div>
            </div>
            {/* <div className="row m-lg-1">
                {tableData?.map((process, index) => (
                    <div key={index} className="col-md-3 col-sm-12">
                        <Alert color="primary" className="p-3">
                            <h5>{process?.processName}</h5>
                            <div
                                style={{
                                    height: "90px",
                                    overflow: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                    // alignItems: "center",
                                    // justifyContent: "center",
                                    // textAlign: "center",
                                }}
                            >
                                <div>
                                    Steps:
                                    <a
                                        className="alert-link fa-solid fa-file"
                                        onClick={() => {
                                            navigate(`/process/record/${process?._id}/add`, { state: { process } });
                                        }}
                                        style={{ cursor: "pointer", fontSize: "24px", margin: "0 10px" }}
                                    />
                                    <a
                                        className="alert-link fa-solid fa-clipboard"
                                        onClick={() => {
                                            navigate(`/process/records/${process?._id}`, { state: { process } });
                                        }}
                                        style={{ cursor: "pointer", fontSize: "24px", margin: "0 15px" }}
                                    />
                                </div>
                                <br />
                                <div>
                                    Verify:
                                    <a
                                        className="alert-link fa-solid fa-file"
                                        onClick={() => {
                                            navigate(`/process/qa-record/${process?._id}/add`, { state: { process, qaRecords: true } });
                                        }}
                                        style={{ cursor: "pointer", fontSize: "24px", margin: "0 10px" }}
                                    />
                                    <a
                                        className="alert-link fa-solid fa-clipboard"
                                        onClick={() => {
                                            navigate(`/process/qa-records/${process?._id}`, { state: { process, qaRecords: true } });
                                        }}
                                        style={{ cursor: "pointer", fontSize: "24px", margin: "0 15px" }}
                                    />
                                </div>
                            </div>

                        </Alert>
                    </div>
                ))}
            </div> */}
            {tableData.length > 0 ? (
                <Table className="table table-hover mt-4" responsive hover>
                    <thead>
                        <tr>
                            <th>Process Name</th>
                            <th>Steps</th>
                            <th>Testing</th>
                            <th>Created By</th>
                            <th>Updated By</th>
                            <th>Updated At</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((data, index) => (
                            <tr key={index}>
                                <td>{data.processName}</td>
                                <td> <div
                                    className="alert-link fa-solid fa-plus-square text-success"
                                    onClick={() => {
                                        navigate(`/process/record/${data?._id}/add`, { state: { process: data } });
                                    }}
                                    style={{ cursor: "pointer", fontSize: "24px", margin: "0 10px" }}
                                />
                                    <i className="fa fa-list-alt text-success" aria-hidden="true" onClick={() => {
                                        navigate(`/process/records/${data?._id}`, { state: { process: data } });
                                    }}
                                        style={{ cursor: "pointer", fontSize: "24px", margin: "0 15px" }} />
                                </td>
                                <td> 
                                <div
                                    className="alert-link fa-solid fa-plus-square text-success"
                                    onClick={() => {
                                            navigate(`/process/qa-record/${data?._id}/add`, { state: { process:data, qaRecords: true } });
                                        }}
                                    style={{ cursor: "pointer", fontSize: "24px", margin: "0 10px" }}
                                />
                                    <i className="fa fa-list-alt text-success" aria-hidden="true" 
                                    onClick={() => {
                                            navigate(`/process/qa-records/${data?._id}`, { state: { process:data, qaRecords: true } });
                                        }}
                                        style={{ cursor: "pointer", fontSize: "24px", margin: "0 15px" }} />
                                </td>
                                <td>{data.createdBy?.name}</td>
                                <td>{data.updatedBy?.name}</td>
                                <td>{moment(data.updatedAt).format("DD/MM/YYYY")}</td>
                                <td className="d-flex">
                                    <i
                                        className="fas fa-edit btn btn-primary m-2"
                                        onClick={() => doEdit(data._id)}
                                        aria-hidden="true"
                                    />
                                    <i
                                        className="fa-solid fa-trash-can btn btn-danger m-2"
                                        onClick={() => doDelete(data._id)}
                                        aria-hidden="true"
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            ) : (
                <div className="text-center mt-4">
                    <h4>No records found.</h4>
                </div>
            )}
        </div>
    );
};

export default Processes;
